module.exports = __webpack_public_path__ + "static/media/MCT-Slider-mobile-5.22903d8e.jpg";